<template>
  <div class="cencent">
    <div class="title">

      <el-button size="mini" type="primary" @click="reload();add_status=true">新增</el-button>
    </div>


    <div class="subject">
      <el-table
        :header-cell-style="{background:'#333333','color':'#fff',border:0}"
        :data="list"
        stripe
        border
        style="width: 90%"
        height="calc(100% - 60px)"
        show-overflow-tooltip="true"
      >
        <el-table-column
          type="index"
          label="序号">
        </el-table-column>

        <el-table-column
          prop="name"
          align="center"
          label="菜单名">
        </el-table-column>


        <el-table-column
          prop="module"
          align="center"
          label="模块标识">
        </el-table-column>

        <el-table-column
          prop="server"
          align="center"
          label="数据库">
        </el-table-column>
        <el-table-column
          prop="url"
          align="center"
          label="文件路径">
        </el-table-column>

        <el-table-column
          prop="class_name"
          align="center"
          label="一级菜单">
        </el-table-column>


        <el-table-column
          align="center"
          label="字段库">
          <template slot-scope="scope">

            <div class="btn-txt" @click="edit_info_field(scope.row)">编辑</div>

          </template>
        </el-table-column>


        <el-table-column
          align="center"
          label="权限">

          <template slot-scope="scope">

            <div class="btn-success" @click="edit_auth(scope.row._id)">编辑</div>
          </template>

        </el-table-column>

        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: space-around">
              <div style="color: #5198f3;cursor: pointer" @click="edit_info(scope.row)">编辑</div>
              <div class="btn-error" v-if="scope.row.is_delete==0" @click="update_status(scope.row,1)">停用</div>
              <div class="btn-success" v-if="scope.row.is_delete==1" @click="update_status(scope.row,0)">启用</div>
            </div>
          </template>
        </el-table-column>


      </el-table>
      <div style="height: 5px"></div>

    </div>


    <el-dialog
      title="提示"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="40px"
      append-to-body
      destroy-on-close
      :visible.sync="add_status"
    >


      <div slot="title" style="text-align: right">
        <el-button type="primary" @click="sub" size="mini">保 存</el-button>
        <el-button @click="add_status = false" size="mini">关 闭</el-button>
      </div>


      <el-form ref="form" size="mini" :model="form" label-width="80px">
        <el-form-item label="菜单名称" required>
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="模块标识" required>
          <el-input v-model="form.module" placeholder="只能为字母"></el-input>
        </el-form-item>
        <el-form-item label="数据库" required>
          <el-input v-model="form.server" placeholder="只能为字母"></el-input>
        </el-form-item>
        <el-form-item label="文件路径" required>
          <el-input v-model="form.url" placeholder="只能为字母"></el-input>
        </el-form-item>

        <el-form-item label="一级菜单" required>

          <el-select @change="selectmenu" clearable v-model="form.class_id" value-key="class_id" placeholder="请选择">
            <el-option
              v-for="item in menulist"
              :key="item._id"
              :label="item.name"
              :value="item._id">
            </el-option>
          </el-select>
        </el-form-item>


      </el-form>


    </el-dialog>
    <el-dialog
      title="提示"
      fullscreen
      :show-close="false"
      style="height: 100%"
      :visible.sync="field_edit_status"
    >

      <div slot="title" style="text-align: right">
        <el-button @click="field_edit_status = false" size="mini">关 闭</el-button>
      </div>
      <authedit :moduleid="moduleid" v-if="field_edit_status"></authedit>

    </el-dialog>


    <!--    字段编辑弹框-->
    <el-dialog
      title="提示"
      fullscreen
      :show-close="false"
      style="height: 100%"
      :visible.sync="field_edit_status_field"
    >

      <div slot="title" style="text-align: right">
        <el-button @click="field_edit_status_field = false" size="mini">关 闭</el-button>
      </div>
      <fieldedit :moduleid="moduleid" :modulename="modulename" v-if="field_edit_status_field"></fieldedit>

    </el-dialog>


    <!--    字段编辑弹框-->
    <el-dialog
      title="提示"
      fullscreen
      :show-close="false"
      style="height: 100%"
      :visible.sync="event_edit_status_field"
    >

      <div slot="title" style="text-align: right">
        <el-button @click="event_edit_status_field = false" size="mini">关 闭</el-button>
      </div>
      <eventedit :moduleid="moduleid" :modulename="modulename" v-if="event_edit_status_field"></eventedit>

    </el-dialog>


  </div>
</template>

<script>

import u from "../../../assets/js/util";
import authedit from "./auth_edit";
import fieldedit from "./field_edit";
import eventedit from "./event_edit";

export default {
  components: {
    authedit,
    eventedit,
    fieldedit
  },
  name: "menu_v1",
  data() {
    return {

      form: {
        name: '',
        module: '',
        server: '',
        url: '',
        class_id: "",
        class_name: "",
        event: {}

      },
      menulist: [],
      memu: "",
      u: u,
      list: [],
      add_status: false,
      field_edit_status: false,
      class_status: false,
      event_edit_status_field: false,
      field_edit_status_field: false,
      editInfo: {},
      moduleid: "",
      modulename: ""
    }
  },
  async mounted() {
    this.get_list()
    this.getmenulist()
  },
  methods: {

    async event_auth(e) {
      this.moduleid = e._id
      this.modulename = e.name
      this.event_edit_status_field = true

    },
    async edit_info_field(e) {
      this.moduleid = e._id
      this.modulename = e.name
      this.field_edit_status_field = true

    },
    async edit_auth(_id) {
      this.moduleid = _id
      this.field_edit_status = true

    },
    async sub() {
      var form = this.form

      if (!form.name) {
        u.error("名称不能空")
        return
      }
      if (!form.module) {
        u.error("模块标识不能空")
        return
      }
      if (!form.server) {
        u.error("数据库不能空")
        return
      }
      if (!form.url) {
        u.error("文件路径不能空")
        return
      }
      if (!form.class_id) {
        u.error("一级菜单不能空")
        return
      }
      var res = await u.post("admin", "menu_v2", form)

      if (res !== false) {
        this.success()
      }

    },
    reload() {
      this.form = {
        name: '',
        module: '',
        url: '',
        class_id: "",
        class_name: ""
      }
    },
    selectmenu(e) {


      var selectdata = {}
      this.menulist.forEach((item) => {
        if (item._id == e) {
          selectdata = item
        }
      })

      this.form.class_id = selectdata._id
      this.form.class_name = selectdata.name

    },

    async getmenulist() {

      var list = await u.post("admin", "querymenu", {})
      this.menulist = list

    },
    async update_status(data, status) {

      this.form = data
      this.form.is_delete = status
      this.sub()


    },
    edit_info(data) {
      this.memu = data.menu_id
      this.form = data
      this.add_status = true
    },


    async get_list(data) {

      this.list = await u.post("admin", "menu_v2query", {})
    },
    success() {
      this.add_status = false
      this.get_list(this.find_data)
      this.reload()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/admin/menu.vue